<template>
	<!-- 拉新纪录 -->
	<div class="mks-page">
		<!-- 筛选卡片 -->
		<div class="mks-filter-card">
			<div class="mks-card-head">
				<div class="mks-card-title">筛选条件</div>
				<div class="mks-card-desc">按客户或手机号检索拉新记录，支持日期范围筛选</div>
			</div>
			<div class="mks-filter-row">
				<div class="mks-field" v-if="this.uobj.pertb005.pertb005cb00 =='CUS-1'">
					<span class="mks-label">客户：</span>
					<el-select v-model="customerMo" placeholder="请选择" filterable remote :remote-method="filterCustomer">
						<el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
							:value="item.ORMTB410ID">
						</el-option>
					</el-select>
				</div>
				<div class="mks-field">
					<span class="mks-label">手机号：</span>
					<input class="mks-input" maxlength="11" type="text" placeholder="请输入" v-model="cusQueryiphone" />
				</div>
			</div>
			<div class="mks-date-row">
				<div class="mks-date-chips">
					<span class="mks-chip" :class="{ 'mks-chip-active': dateNowDayActive }" @click="getNowDay">当日</span>
					<span class="mks-chip" :class="{ 'mks-chip-active': dateYesterdayActive }" @click="getYesterday">昨天</span>
					<span class="mks-chip" :class="{ 'mks-chip-active': dateNowMonthActive }" @click="sameMonth">当月</span>
					<span class="mks-chip" :class="{ 'mks-chip-active': dateLastMonthActive }" @click="lastMonth">上月</span>
					<el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
						range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
						start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
				</div>
				<div class="mks-actions">
					<button @click="queryClick" class="public_saleWater_chaxun" v-shiroHiden="solelist" id="查询">
						<i class="iconfont icon-chaxun"></i>查询
					</button>
					<el-button class="public_saleWater_daochu" :loading="loadingBut" @click="exports"
						v-shiroHiden="solelist" id="导出">
						<i class="iconfont icon-daochu"></i>导出<span v-if="confirmTxt > 0">{{confirmTxt}}</span>
					</el-button>
				</div>
			</div>
		</div>

		<!-- 统计卡片 -->
		<div class="mks-stat-row">
			<div class="mks-stat-card mks-stat-blue">
				<div class="mks-stat-icon">
					<img src="../../assets/images/orderStatistics/lxzc.png">
				</div>
				<div class="mks-stat-info">
					<div class="mks-stat-label">拉新总支出(元)</div>
					<div class="mks-stat-value" style="color:#2689e8;">{{lxzc}}</div>
				</div>
			</div>
			<div class="mks-stat-card mks-stat-green">
				<div class="mks-stat-icon">
					<img src="../../assets/images/orderStatistics/zlxyh.png">
				</div>
				<div class="mks-stat-info">
					<div class="mks-stat-label">总拉新用户(人)</div>
					<div class="mks-stat-value" style="color:#08d691;">{{xyhzs}}</div>
				</div>
			</div>
			<div class="mks-stat-card mks-stat-orange">
				<div class="mks-stat-icon">
					<img src="../../assets/images/orderStatistics/lxzds.png">
				</div>
				<div class="mks-stat-info">
					<div class="mks-stat-label">被邀请人总下单数(单)</div>
					<div class="mks-stat-value" style="color:#ff6b35;">{{xyhzds}}</div>
				</div>
			</div>
		</div>

		<!-- 表格卡片 -->
		<div class="mks-table-card">
			<div class="mks-card-head">
				<div class="mks-card-title">拉新记录</div>
				<div class="mks-card-desc">共 {{ pagingPageMo }} 条记录</div>
			</div>
			<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
				:default-sort="{prop: 'waterNum', order: 'descending'}"
				:header-cell-style="{color:'rgba(51,51,51,1)', background:'rgba(184,227,255,1)','font-weight':'bold'}"
				class="public_tableColumn">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<div class="yqmain" v-for="(item, i) in props.row.list">
								<div style="display: flex;">
									<el-form-item label="被邀请人:">
										<span>{{item.pertb008CA03}}</span>
									</el-form-item>
									<el-form-item label="被邀请人下单数:">
										<span>{{item.pertb008CA06}}</span>
									</el-form-item>
									<el-form-item label="邀请人收益:">
										<span>{{item.pertb008CA05}}</span>
									</el-form-item>
								</div>
							</div>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="pertb008CA08" label="邀请发起人">
					<template slot-scope="scope">
						<p>
							<span>{{scope.row.pertb008CA08}}</span>
						</p>
						<p style="color: #999;">
							<span>{{scope.row.pertb008CA09}}</span>
						</p>

					</template>
				</el-table-column>
				<el-table-column prop="pertb008CA07" label="邀请人数">
				</el-table-column>
				<el-table-column prop="pertb008CA05" label="总收益">
				</el-table-column>
				<el-table-column prop="pertb008CA06" label="被邀请人下总单数">
				</el-table-column>

			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>

		<div class="public-dialog">
			<el-dialog title="详情" :visible.sync="oerderDetilsShow" width="35%" @close="detailsList=''"
				:closeOnClickModal='false' append-to-body custom-class="mar-keting-set-dialog">
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">流水号</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">客户名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单方式</div>
						<div class="DWD-li-text">
							{{detailsList.ORMTB440CF00=='ZG'?'直供':detailsList.ORMTB440CF00=='LS'?'零售':detailsList.ORMTB440CF00=='QD'?'抢单':''}}
						</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA19||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">结算时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CC00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">回执时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CE00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">原因</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CD01||''}}</div>
					</div>
					<div class="DWD-table">
						<div class="DWD-table-left-title">
							<div></div>
							<div>派单</div>
							<div>结算</div>
							<div>回执</div>
						</div>
						<div class="DWD-table-left-flex">
							<div>物料</div>
							<div>{{detailsList.ORMTB440CA07||''}}</div>
							<div>{{detailsList.ORMTB440CC02||''}}</div>
							<div></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>单价</div>
							<div>{{detailsList.ORMTB440CA08||''}}</div>
							<div>{{detailsList.ORMTB440CC03||''}}</div>
							<div></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>重量</div>
							<div>{{detailsList.ORMTB440CA10||0}}</div>
							<div>{{detailsList.ORMTB440CC04||0}}</div>
							<div v-if="detailsList.ORMTB440CF01=='5'">{{detailsList.ORMTB440CE09||0}}</div>
							<div v-else></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>物料金额</div>
							<div>{{detailsList.ORMTB440CA11||0}}</div>
							<div>{{detailsList.ORMTB440CC06||0}}</div>
							<div></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>运费金额</div>
							<div>{{detailsList.ORMTB440CA12||0}}</div>
							<div>{{detailsList.jsORMTB440CA12||0}}</div>
							<div v-if="detailsList.ORMTB440CF01=='5'">{{detailsList.ORMTB440CE10||0}}</div>
							<div v-else></div>
						</div>
					</div>
				</div>
				<div class="DetailsWater-img">
					<div class="DetailsWater-img-text">回执记录</div>
					<el-image style="width: 80px; height: 80px" :src="DetailsWaterurl"
						:preview-src-list="DetailsWatersrcList">
					</el-image>
				</div>
				<div v-if="detailsList.ORMTB440CH05" class="DetailsWater-img">
					<div class="DetailsWater-img-text">磅单</div>
					<el-image style="width: 80px; height: 80px" :src="detailsList.ORMTB440CH05"
						:preview-src-list="DetailsWeightrcList">
					</el-image>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="审核" :visible.sync="orderAuditShow" @close="detailsList=''" width="30%"
				:closeOnClickModal='false' append-to-body custom-class="mar-keting-set-dialog">
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">客户名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">物料名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA07||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">重量</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA10||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="orderAuditServe(1)">通过</el-button>
					<el-button type="danger" @click="orderAuditServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="审核" :visible.sync="isorderAuditShow" @close="detailsList='',isorderAuditText=''"
				width="30%" :closeOnClickModal='false' append-to-body custom-class="mar-keting-set-dialog">
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">客户名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">物料名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA07||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">重量</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA10||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单物料金额</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA11||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单运费</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA12||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核说明</div>
						<div class="DWD-li-text">
							<input type="text" v-model="isorderAuditText" maxlength="20">
						</div>
					</div>

				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="isorderAuditServe(1)">通过</el-button>
					<el-button type="danger" @click="isorderAuditServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="详情" :visible.sync="returnReceiptShow" @close="detailsList=''" width="30%"
				:closeOnClickModal='false' append-to-body custom-class="mar-keting-set-dialog">
				<div class="CustomerfillingDig-tab">
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">车牌号：</div>
						<div class="CustomerfillingDig-tab-li-ipt">{{detailsList.ORMTB440CA01||''}}</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">回执物料：</div>
						<div class="CustomerfillingDig-tab-li-ipt">{{detailsList.ORMTB440CA07||''}}</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">回执重量：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input ref="topWeight" type="text" v-model="detailsList.ORMTB440CE02" maxlength="10"
								@input="topWeightInput" @change="topWeightChange">
						</div>
						<div class="CustomerfillingDig-tab-li-b">*必填*</div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">回执运费单价：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input ref="topMoney" type="text" v-model="detailsList.ORMTB440CA21" maxlength="10"
								@input="topMoneyInput" @change="topMoneyChange">
						</div>
						<div class="CustomerfillingDig-tab-li-b">*必填*</div>
					</div>
				</div>
				<div class="DetailsWater-img">
					<div class="DetailsWater-img-text">回执记录</div>
					<el-image style="width: 80px; height: 80px" :src="DetailsWaterurl"
						:preview-src-list="DetailsWatersrcList">
					</el-image>
				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="returnReceiptserve">确定</el-button>
				</div>
			</el-dialog>
		</div>

		<div class="public-dialog">
			<el-dialog title="详情" :visible.sync="inputWeightShow" @close="inputWeightClose" width="30%"
				:closeOnClickModal='false' append-to-body custom-class="mar-keting-set-dialog">
				<div class="CustomerfillingDig-tab">
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">派单物料：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<!-- <input type="text" v-model="detailsList.ORMTB440CA07" disabled> -->
							<el-select v-model="materialValue" placeholder="请选择" @change="materialChange">
								<el-option v-for="item in materialList" :key="item.value" :label="item.lable"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">单价：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="number" v-model="weightOpt.price" maxlength="10"
								@input="inputWeightFormat($event,'price')">
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">毛重：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="number" v-model="weightOpt.tare" maxlength="10"
								@input="inputWeightFormat($event,'tare')">
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">皮重：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="number" v-model="weightOpt.gross" maxlength="10"
								@input="inputWeightFormat($event,'gross')">
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">净重：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="text" v-model="detailsList.ORMTB440CC04" maxlength="10" disabled>
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">结算金额：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="text" v-model="detailsList.ORMTB440CC06" maxlength="100" disabled>
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="inputWeightConfirm">确定</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>


<script>
	import qs from 'qs'
	import {
		createLogger
	} from 'vuex';
	import debounce from '../../api/debounce';
import customerSearchMixin from '@/mixins/customerSearchMixin'
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
	export default {
  mixins: [customerSearchMixin, enterpriseSearchMixin],
		data() {
			return {
				weightOpt: {
					tare: '',
					gross: '',
					price: ''
				},
				loadingBut: false,
				confirmTxt: 0,
				inputWeightShow: false, // 输入磅单信息弹窗
				isorderAuditText: '',
				oerderDetilsShow: false,
				orderAuditShow: false,
				isorderAuditShow: false,
				returnReceiptShow: false,
				uobj: this.$store.state.uobj, //登陆缓存--用户信息
				date: [], //日期
				startTime: '',
				endTime: '',
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,
				twolevelUserLogin: true,
				timeIndex: 0, //判断第几次切换当月时间
				sameMonthTime: '', //目前月份
				currentMonthTime: '', //目前月份--上月+1
				tableData: [],
				ORMTB440CA00: '',
				cusQueryiphone:'',
				materialOptions: [],
				materialTypeValue: '',
				carNum: '',
				materielMo: '',
				materielOptions: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}],
				// 状态
				dataStatusOperation: [{
					value: '',
					label: '全部',
				}, {
					value: '0',
					label: '待接单',
				}, {
					value: '1',
					label: '待提货',
				}, {
					value: '2',
					label: '提货中',
				}, {
					value: '3',
					label: '完成',
				}, {
					value: '4',
					label: '回执',
				}, {
					value: '5',
					label: '确认回执',
				}, {
					value: '-1',
					label: '取消',
				}, {
					value: '9',
					label: '取消申请',
				}],
				lxzc: 0,
				xyhzs: 0,
				xyhzds: 0,
				// 查询
				customerMo: '', //客户--查询		
				SETTB122CA07: '', //数据状态
				billOperationAdd: false,
				enterpriseTwoOptionList: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}], //二级企业下拉框--新增
				enterpriseTwo: '', //二级企业
				carNumber: '', //车牌号
				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				// 列设置
				checkAll: true,
				checkedCities: ['派单时间', '派单编号', '企业名称', '客户名称', '车牌号', '订单物料', '完成物料', '重量', '完成状态', '申请状态'],
      filteredEnterpriseOptions: [],
				cities: ['派单时间', '派单编号', '企业名称', '客户名称', '车牌号', '订单物料', '完成物料', '重量', '完成状态', '申请状态'],
				isIndeterminate: false,
				// 详情
				billOperationDetails: false,
				detailsList: '', //详情列表
				tableHeadList: [
					// {
					// 	prop: 'ORMTB440CA19',
					// 	label: '派单时间',
					// 	width: 110
					// },
					// {
					// 	prop: 'ORMTB440CA00',
					// 	label: '派单编号',
					// 	width: 130
					// },
					// {
					// 	prop: 'ORMTB440CA05',
					// 	label: '企业名称',
					// },
					// {
					// 	prop: 'ORMTB440CA03',
					// 	label: '客户名称',
					// },

					{
						prop: 'ORMTB440CA01',
						label: '车牌号',
						width: 100
					},
					{
						prop: 'ORMTB440CA07',
						label: '订单物料',
						width: 100
					},
					{
						prop: 'ORMTB440CC02',
						label: '完成物料',
						width: 100
					},
					{
						prop: 'ORMTB440CA10',
						label: '重量',
					},
					{
						prop: 'ORMTB440CC00',
						label: '结算时间',
						width: 110
					},
					{
						prop: 'ORMTB440CC06',
						label: '结算金额',
						width: 110
					},
					{
						prop: 'ORMTB440CC07',
						label: '流水号',
						width: 130
					}
					// {
					// 	prop: 'ORMTB440CF01text',
					// 	label: '完成状态',
					// 	width: 100
					// }
					// {
					// 	prop: 'auditText',
					// 	label: '申请状态',
					// 	width: 100
					// }
				],
				tableHeadListInit: [{
						prop: 'ORMTB440CA19',
						label: '派单时间',
					},
					{
						prop: 'ORMTB440CA00',
						label: '派单编号',
					},
					{
						prop: 'ORMTB440CA05',
						label: '企业名称',
					},
					{
						prop: 'ORMTB440CA03',
						label: '客户名称',
					},

					{
						prop: 'ORMTB440CA01',
						label: '车牌号',
					},
					{
						prop: 'ORMTB440CA07',
						label: '订单物料',
					},
					{
						prop: 'ORMTB440CC02',
						label: '完成物料',
					},
					{
						prop: 'ORMTB440CA10',
						label: '重量',
					},
					{
						prop: 'ORMTB440CF01text',
						label: '完成状态',
					},
					{
						prop: 'auditText',
						label: '申请状态',
					},
				],
				isRefresh: true,
				isRefreshSetInterval: '',
				// quanpDisabled: false,
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				solelist: [],
				DetailsWaterurl: '',
				DetailsWatersrcList: [],
				DetailsWeightrcList: [],
				materialList: [],
				materialValue: '',
				listTick: null, // 列表刷新定时器
				timeType: '1'
			}
		},
		watch: {
			weightOpt: {
				handler(val) {
					if ((val.tare || val.tare === 0) && (val.gross || val.gross === 0) && (val.price || val.price === 0)) {
						let tare = parseFloat(val.tare)
						let gross = parseFloat(val.gross)
						this.detailsList.ORMTB440CC04 = (tare - gross).toFixed(2)
						if (this.detailsList.ORMTB440CC04) {
							debounce(this.getSettlementAmount, 500)
						}
					} else {
						this.detailsList.ORMTB440CC04 = ''
						this.detailsList.ORMTB440CC06 = ''
					}
				},
				deep: true
			},
			// 'detailsList.ORMTB440CA04'() {
			//     this.getSelectMaterial()
			// }
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			// console.log(list)
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}
			// console.log(this.historyInfo)
			// else {
			// 	this.getNowDay();
			// }
			var path = this.$route.path;
			if (path === '/SalesDispatchManagement') {
				path = '/Home' + path
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		},
		mounted() {
			if (this.historyInfo == null && this.$route.query.mark == null) {
				this.getNowDay();
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = true
			}

			// this.optionLists()
			this.enterprise0ptions()
			this.enterprise2Options()
			this.queryClick()
			// this.listTick = setInterval(() => {
			// 	this.queryClick()
			// }, 1000 * 60)
			// console.log(this.$store.state.uobj)
		},
		// 存储数据
		beforeDestroy() {
			clearInterval(this.listTick)
			this.listTick = null
			this.startTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[0]));
			this.endTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[1]));
			var obj = {
				startTime: this.startTime,
				endTime: this.endTime, //开始时间
				ORMTB440CA02: this.ORMTB440CA02, //客户id
				ORMTB400CA03: this.ORMTB400CA03, //客户名称
				ORMTB440CA04: this.ORMTB440CA04, //客户名称
				ORMTB440CA06: this.ORMTB440CA06, //二级企业id
				ORMTB440CF01: this.ORMTB440CF01, //二级企业名称
				ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
				ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo, //每页条数
				dateNowDayActive: this.dateNowDayActive,
				dateYesterdayActive: this.dateYesterdayActive,
				dateNowMonthActive: this.dateNowMonthActive,
				dateLastMonthActive: this.dateLastMonthActive,
				ORMTB440CA00: this.ORMTB440CA00
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
			// 值改变 重新获取结算金额
			async materialChange(val) {
				if (val == this.detailsList.ORMTB440CC01) {
					this.weightOpt.price = this.detailsList.ORMTB440CA08
				} else {
					await this.queryMaterialPrice(val)
				}
				this.getSettlementAmount()
			},
			// 根据物料id 查询单价
			async queryMaterialPrice(ORMTB440CC01) {
				let url = '/orm/ormtb440/unitPriceAuto'
				let params = {
					ORMTB440CC01, // 结算物料id
					ORMTB440CA02: this.detailsList.ORMTB440CA02, //客户id
					ORMTB440CA04: this.detailsList.ORMTB440CA04, // 二级企业ID
				}
				params = qs.stringify(params)
				let header = {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
				let res = await this.axios.post(url, params, {
					header
				})
				if (res.data.code === 200) {
					this.weightOpt.price = res.data.data
				}
			},
			// 获取派单物料列表
			getSelectMaterial() {
				var postData = {
					SETTB99ID: this.detailsList.ORMTB440CA04
				}
				this.materialList = []
				postData = qs.stringify(postData)
				var url = "/set/settb109/select_material";
				this.axios.post(url, postData, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(res => {
					if (res.data.code == 200) {
						this.materialList = res.data.data
						// this.materialValue = this.detailsList.ORMTB440CC01
						if (this.detailsList.ORMTB440CC01) {
							this.materialValue = this.detailsList.ORMTB440CC01
						} else {
							this.materialValue = this.detailsList.ORMTB440CA06
							this.queryMaterialPrice(this.materialValue)
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			//初始化数据
			init() {
				this.startTime = this.historyInfo.startTime
				this.endTime = this.historyInfo.endTime
				this.date = [this.startTime, this.endTime]
				this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
				this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
				this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
				this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
				this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
				this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
			},
			// 导出
			exports() {
				// console.log(this.uobj)
				if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
					this.customerMo = this.uobj.ormtb410.ORMTB410ID //一级企业id

				}
				var startTime = this.date[0]; //开始时间
				var endTime = this.date[1]; //结束时间
				var ORMTB440CA02 = this.customerMo; //二级客户ID
				var ORMTB400CA03 = 1002; //一级客户代码
				var ORMTB440CA04 = this.enterpriseTwo; //二级企业ID
				var ORMTB440CA06 = this.materielMo; //物料ID
				var ORMTB440CF01 = this.SETTB122CA07; //状态
				var ORMTB440CA00 = this.ORMTB440CA00; //订单号
				var ORMTB440CA01 = this.carNumber; //车牌号
				var timeType = this.timeType; //
				var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb440toExcle?startTime=" + startTime +
					"&endTime=" +
					endTime + "&ORMTB440CA02=" + ORMTB440CA02 + "&ORMTB400CA03=" + ORMTB400CA03 +
					"&ORMTB440CA04=" + ORMTB440CA04 + "&ORMTB440CA06=" + ORMTB440CA06 + "&ORMTB440CF01=" +
					ORMTB440CF01 + "&ORMTB440CA00=" + ORMTB440CA00 + "&ORMTB440CA01=" + ORMTB440CA01 + "&timeType=" +
					timeType;
				window.location.href = url;

				this.loadingBut = true
				var timer = null //倒计时
				this.confirmTxt = 30 - 1
				timer = setInterval(() => {
					if (this.confirmTxt === 0) {
						this.confirmTxt = ""
						this.loadingBut = false
						clearInterval(timer);
					} else {
						this.confirmTxt--
					}
				}, 1000);

			},
			topWeightInput() {
				this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/^\./g, ""); //验证第一个字符是数字
				this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(".", "$#$").replace(/\./g, "")
					.replace("$#$", ".");
				this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/^(\-)*(\d+)\.(\d\d).*$/,
					'$1$2.$3'); //只能输入两个小数
				if (this.detailsList.ORMTB440CE02.indexOf(".") < 0 && this.detailsList.ORMTB440CE02 !=
					"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.detailsList.ORMTB440CE02 = parseFloat(this.detailsList.ORMTB440CE02);
				}
				this.$refs.topWeight.value = this.detailsList.ORMTB440CE02
			},
			topWeightChange() {
				var index = String(this.detailsList.ORMTB440CE02).indexOf('.')
				if (index == -1) return
				var numArr = this.detailsList.ORMTB440CE02.split('.')
				if (numArr[1].length == 0) {
					this.$refs.topWeight.value = numArr[0]
					this.detailsList.ORMTB440CE02 = numArr[0]
				} else {
					this.$refs.topWeight.value = numArr[0] + '.' + numArr[1]
					this.detailsList.ORMTB440CE02 = numArr[0] + '.' + numArr[1]
				}
			},
			topMoneyInput() { //充值金额实时校验
				this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/^\./g, ""); //验证第一个字符是数字
				this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(".", "$#$").replace(/\./g, "")
					.replace("$#$", ".");
				this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/^(\-)*(\d+)\.(\d\d).*$/,
					'$1$2.$3'); //只能输入两个小数
				if (this.detailsList.ORMTB440CA21.indexOf(".") < 0 && this.detailsList.ORMTB440CA21 !=
					"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.detailsList.ORMTB440CA21 = parseFloat(this.detailsList.ORMTB440CA21);
				}
				this.$refs.topMoney.value = this.detailsList.ORMTB440CA21
			},
			topMoneyChange() { //充值金额失去焦点数据处理
				var index = String(this.detailsList.ORMTB440CA21).indexOf('.')
				if (index == -1) return
				var numArr = this.detailsList.ORMTB440CA21.split('.')
				if (numArr[1].length == 0) {
					this.$refs.topMoney.value = numArr[0]
					this.detailsList.ORMTB440CA21 = numArr[0]
				} else {
					this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
					this.detailsList.ORMTB440CA21 = numArr[0] + '.' + numArr[1]
				}
			},
			returnReceiptserve() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB440CE07: this.uobj.pertb005.pertb005id, //开始时间
					ORMTB440CE08: this.uobj.pertb005.pertb005ca02,
					ORMTB440CE09: this.detailsList.ORMTB440CE02,
					ORMTB440ID: this.detailsList.ORMTB440ID,
					ORMTB440CA21: this.detailsList.ORMTB440CA21,
				}
				this.tableData = [];
				var url = "/orm/ormtb440/ormtb440Confirm";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '确认回执成功',
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			// 取消订单
			cancelOrder(row) {
				var url = "/orm/ormtb440/updateORMTB440CF01";
				this.$prompt('请输入取消原因', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^.{1,}$/,
					inputErrorMessage: '原因不能为空'
				}).then(({
					value
				}) => {
					var postData = {
						ORMTB440ID: row.ORMTB440ID,
						ORMTB440CF01: -1, //状态
						ORMTB440CD01: value, //取消原因
					}
					let loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					this.axios.post(url, postData).then(res => {
						if (res.data.code == 200) {
							this.pageList()
							this.$message({
								type: 'success',
								message: '取消成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						loading.close();
					}).catch(() => {
						loading.close();
					})
				})
			},
			materielMoPost() {
				var i = (this.enterpriseTwoOptionList || []).findIndex((profile) => profile.SETTB99ID === this
					.enterpriseTwo);
				var url = "/set/settb109/selectPageList";
				var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
				var data = {
					SETTB109CA03: '',
					SETTB109CA00: '',
					SETTB109CD01: SETTB100ID,
					SETTB99ID: this.enterpriseTwo,
					page: 1,
					limit: 1000,
				};
				var List = [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}];
				this.axios.post(url, data).then(res => {
					if (res.data.code == 200) {
						this.materielOptions = [...List, ...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			erpChange() {
				if (this.enterpriseTwo != '') {
					this.materielMoPost()
				} else {
					this.materielOptions = [{
						SETTB109CA00: '全部',
						SETTB109ID: '',
					}]
				}
			},
			// 查询
			queryClick() {
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.pageList()
			},
			// 列表
			pageList() {
				var ORMTB400CA03
				// console.log(this.uobj.ormtb410)
				if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
					ORMTB400CA03 = this.uobj.ormtb410.ORMTB410ID
				}
				if (this.uobj.pertb005.pertb005cb00 == "CUS-1") {
					ORMTB400CA03 = this.uobj.ormtb400.ORMTB400CA03
				}

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					startTime: this.startTime, //开始时间
					endTime: this.endTime, //结束时间
					PERTB008CA01: this.customerMo, //二级客户ID
					PERTB008CA07:this.cusQueryiphone,//手机号
					// ORMTB400CA03: ORMTB400CA03, //一级客户代码
					// ORMTB440CA04: this.enterpriseTwo, //二级企业ID
					// ORMTB440CA06: this.materielMo, //物料ID
					// ORMTB440CF01: this.SETTB122CA07, //状态
					// ORMTB440CA00: this.ORMTB440CA00, //订单号
					// ORMTB440CA01: this.carNumber, //车牌号
					page: this.pageMo,
					limit: this.limitMo
					// timeType: this.timeType
				}
				this.tableData = [];
				var url = "/per/pertb008/selectList";
				this.axios.post(url,postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					// console.log(res)
					if (res.data.code == 200) {
						// console.log(res)
						var data = res.data.data.list;
						// console.log(data)
						this.pagingPageMo = res.data.count;
						
						this.tableData = data;
						this.lxzc = res.data.data.zzc
						this.xyhzds = res.data.data.zds
						this.xyhzs = res.data.data.zyh
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			UploadClick(row) {
				this.ormtb440ca00 = row.ORMTB440CA00
			},
			inputFileChange(e) {
				let file = e.target.files[0]
				let formData = new FormData()
				formData.append('file', file)
				formData.append('ormtb440ca00', this.ormtb440ca00)
				let loading = this.$loading({
					lock: true,
					text: '上传中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/orm/ormtb440/upload";
				this.axios.post(url, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.pageList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			inputWeightClick(row) {
				this.inputWeightShow = true
				this.querydetile(row)
			},
			inputWeightClose() {
				this.weightOpt.tare = ''
				this.weightOpt.gross = ''
				this.detailsList.ORMTB440CC02 = ''
				this.detailsList.ORMTB440CC02 = ''
				this.detailsList.ORMTB440CC04 = ''
				this.detailsList.ORMTB440CC06 = ''
			},
			// 获取结算金额
			async getSettlementAmount() {
				if (!this.materialValue) return
				if (this.weightOpt.price < 0) return
				if (!this.detailsList.ORMTB440CC04) return
				var params = {
					ORMTB440CC01: this.materialValue,
					ORMTB440CA02: this.detailsList.ORMTB440CA02,
					ORMTB440CA04: this.detailsList.ORMTB440CA04,
					ORMTB440CC03: this.detailsList.ORMTB440CC03,
					ORMTB440CC04: this.detailsList.ORMTB440CC04,
					ORMTB440CC03: this.weightOpt.price
				}
				params = qs.stringify(params)
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/orm/ormtb440/orderCompleteBeforeBack";
				this.axios.post(url, params, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.detailsList.ORMTB440CC06 = res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			inputWeightConfirm() {
				var {
					ORMTB440ID, // 派单记录ID - 隐藏
					ORMTB440CC04, // 结算重量 -不修改
					// ORMTB440CC06, // 结算金额 -可修改
				} = this.detailsList
				var ORMTB440CC01 = this.materialValue // 物料id
				var ORMTB440CA07 = this.materialList.find(em => em.value === this.materialValue).lable // 结算物料 -可修改
				var {
					tare,
					gross
				} = this.weightOpt
				if (!tare) {
					return this.$message({
						message: '请输入毛重',
						type: 'error'
					});
				}
				if (!gross) {
					return this.$message({
						message: '请输入皮重',
						type: 'error'
					});
				}
				var params = {
					ORMTB440ID,
					ORMTB440CC01, // 物料id
					ORMTB440CC02: ORMTB440CA07,
					ORMTB440CC04,
					ORMTB440CC03: this.weightOpt.price
				}
				params = qs.stringify(params)

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/orm/ormtb440/update";
				this.axios.post(url, params, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.tableData = [];
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.inputWeightShow = false
						this.pageList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			inputWeightFormat(e, type) {
				let value = e.target.value
				value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				value = value.replace(/^\./g, ""); //验证第一个字符是数字
				value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					value = parseFloat(value);
				}
				setTimeout(() => {
					this.weightOpt[type] = value
				}, 0);
			},
			inputWeightTotalFormat(e) {
				let value = e.target.value
				value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				value = value.replace(/^\./g, ""); //验证第一个字符是数字
				value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					value = parseFloat(value);
				}
				this.detailsList.ORMTB440CC06 = value
			},
			// 详情
			DetailsClick(row) {
				this.oerderDetilsShow = true;
				this.querydetile(row)
			},
			orderAudit(row) {
				this.orderAuditShow = true
				this.querydetile(row)
			},
			isorderAudit(row) {
				this.isorderAuditShow = true
				this.querydetile(row)
			},
			returnReceipt(row) {
				this.returnReceiptShow = true
				this.querydetile(row)
			},
			orderAuditServe(type) {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB440CG00: type,
					ORMTB440CG02: this.uobj.pertb005.pertb005ca02,
					ORMTB440ID: this.detailsList.ORMTB440ID,
					ORMTB440CA02: this.detailsList.ORMTB440CA02,
					ORMTB440CA11: this.detailsList.ORMTB440CA11,
					ORMTB440CA12: this.detailsList.ORMTB440CA12,
				}
				this.tableData = [];
				var url = "/orm/ormtb440/updateORMTB440CG00";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '审核成功',
							type: 'success'
						});
						this.orderAuditShow = false
						this.pageList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			isorderAuditServe(type) {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB440CH01: type,
					ORMTB440CH03: this.uobj.pertb005.pertb005ca02,
					ORMTB440ID: this.detailsList.ORMTB440ID,
					ORMTB440CA02: this.detailsList.ORMTB440CA02,
					ORMTB440CA11: this.detailsList.ORMTB440CA11,
					ORMTB440CA12: this.detailsList.ORMTB440CA12,
					ORMTB440CH04: this.isorderAuditText,
				}
				this.tableData = [];
				var url = "/orm/ormtb440/updateORMTB440CH01";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '审核成功',
							type: 'success'
						});
						this.isorderAuditShow = false
						this.pageList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			querydetile(row) {
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				this.detailsList = ''
				var url = "/orm/ormtb440/selectDetails";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.detailsList = res.data.data;
						this.DetailsWatersrcList = [this.detailsList.ORMTB440CE01]
						if (this.detailsList.ORMTB440CH05) this.DetailsWeightrcList = [this.detailsList
							.ORMTB440CH05
						]
						this.DetailsWaterurl = this.detailsList.ORMTB440CE01
						if (this.detailsList.ORMTB440CF01 == 6 || (row.ORMTB440CF01 == 0 && row.ORMTB440CA22)) {
							this.weightOpt.price = this.detailsList.ORMTB440CC03
							if (this.detailsList.ORMTB440CC06 == 0) this.detailsList.ORMTB440CC06 = ''
							this.weightOpt.tare = this.detailsList.ORMTB440CC05
							this.weightOpt.gross = (this.detailsList.ORMTB440CC05 - this.detailsList.ORMTB440CC04)
								.toFixed(2)
							this.getSelectMaterial()
						}
						// else if (this.detailsList.ORMTB440CF01 == 0) {
						// 	this.weightOpt.price = this.detailsList.ORMTB440CC03
						// 	this.getSelectMaterial()
						// } 

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}

				})
			},
			handleCheckAllChange(val) {
				this.checkedCities = val ? this.cities : [];
				this.isIndeterminate = false;
				this.tableHeadList = val ? this.tableHeadListInit : []
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cities.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
				var changearr = this.checkedCities;
				var initarr = this.tableHeadListInit;
				this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr);
			},


			dateFtt(fmt, date) { //author: meizz
				var o = {
					"M+": date.getMonth() + 1, //月份 
					"d+": date.getDate(), //日 
					"h+": date.getHours(), //小时 
					"m+": date.getMinutes(), //分 
					"s+": date.getSeconds(), //秒 
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度 
					"S": date.getMilliseconds() //毫秒 
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
							.length)));
				return fmt;
			},

			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
				var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
				data = `${data} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [enddata, data];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
				var Ming = new Date().getTime();
				var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				nowDay = `${nowDay} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [nowDay, enddata];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
				firstDay = `${firstDay} ${this.exchangeTiem||'00:00:00'}`
				var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
				var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
				nextDay = `${nextDay} ${this.exchangeTiem||'00:00:00'}`
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
			},
			//获取上月时间
			lastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				var lastyear = year
				var lastmonth = month
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month == 12) {
					lastmonth = 1
				} else {
					lastmonth = lastmonth + (1 * 1)
				}
				if (month < 10) {
					month = "0" + month;
				}
				if (lastmonth < 10) {
					lastmonth = "0" + lastmonth;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem||'00:00:00'}`;
				// var lastDay = new Date(lastyear, lastmonth, 0);
				let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem||'00:00:00'}`;
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
			},
			handleSizeChange(val) {
				this.pageMo = 1
				this.limitMo = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.pageMo = val;
				this.pageList();
			},
		}
	}
</script>

<style scoped>
/* ── 页面容器 ── */
.mks-page {
	width: 100%;
	min-height: 100%;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 14px;
	padding: 0;
	box-sizing: border-box;
	background:
		radial-gradient(circle at 12% 8%, rgba(38, 137, 232, .12), transparent 28%),
		linear-gradient(180deg, #f6faff 0%, #eef5fb 100%);
}

.mks-page > * {
	width: 100%;
	min-width: 0;
	box-sizing: border-box;
}

/* ── 公共卡片 ── */
.mks-filter-card,
.mks-table-card {
	position: relative;
	padding: 16px 18px 18px;
	border: 1px solid rgba(217, 231, 243, .96);
	border-radius: 16px;
	background: rgba(255, 255, 255, .98);
	box-shadow: 0 8px 24px rgba(31, 93, 154, .08);
	overflow: hidden;
}

.mks-filter-card::after,
.mks-table-card::after {
	position: absolute;
	top: 0; left: 0;
	width: 100%; height: 3px;
	content: '';
	background: linear-gradient(90deg, #2689e8, #69c0ff, rgba(105, 192, 255, 0));
}

/* ── 卡片头部 ── */
.mks-card-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 14px;
}

.mks-card-title {
	position: relative;
	padding-left: 12px;
	color: #183b5b;
	font-size: 16px;
	font-weight: 800;
	line-height: 1.2;
	white-space: nowrap;
}

.mks-card-title::before {
	position: absolute;
	top: 2px; bottom: 2px; left: 0;
	width: 4px;
	border-radius: 4px;
	content: '';
	background: #2689e8;
}

.mks-card-desc {
	color: #7b8fa6;
	font-size: 13px;
	line-height: 1.4;
}

/* ── 筛选行 ── */
.mks-filter-row {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px 20px;
	margin-bottom: 12px;
}

.mks-field {
	display: flex;
	align-items: center;
	gap: 8px;
}

.mks-label {
	flex-shrink: 0;
	color: #51687f;
	font-size: 14px;
	font-weight: 600;
	white-space: nowrap;
}

.mks-field /deep/ .el-select {
	width: 220px;
}

.mks-field /deep/ .el-input__inner {
	height: 36px;
	line-height: 36px;
	border-radius: 8px;
	border-color: #d9e7f3;
	background: #f8fbff;
	font-size: 14px;
}

.mks-input {
	width: 200px;
	height: 36px;
	padding: 0 12px;
	border: 1px solid #d9e7f3;
	border-radius: 8px;
	background: #f8fbff;
	color: #273b4f;
	font-size: 14px;
	box-sizing: border-box;
	outline: none;
	transition: border-color .18s, box-shadow .18s;
}

.mks-input:focus {
	border-color: #2689e8;
	background: #fff;
	box-shadow: 0 0 0 3px rgba(38, 137, 232, .12);
}

/* ── 日期行 ── */
.mks-date-row {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
}

.mks-date-chips {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px;
}

.mks-chip {
	display: inline-flex;
	align-items: center;
	height: 34px;
	padding: 0 16px;
	border: 1px solid #d9e7f3;
	border-radius: 999px;
	background: #fff;
	color: #51687f;
	font-size: 13px;
	cursor: pointer;
	transition: all .18s;
	user-select: none;
}

.mks-chip:hover {
	border-color: #a8ccf0;
	color: #2689e8;
}

.mks-chip-active {
	border-color: rgba(38, 137, 232, .3);
	background: linear-gradient(135deg, rgba(38, 137, 232, .14), rgba(38, 137, 232, .06));
	color: #2689e8;
	font-weight: 700;
}

.mks-date-chips /deep/ .el-date-editor {
	width: 340px;
}

.mks-date-chips /deep/ .el-range-input,
.mks-date-chips /deep/ .el-range-separator {
	font-size: 13px;
}

.mks-actions {
	display: flex;
	align-items: center;
	gap: 8px;
}

.mks-actions .public_saleWater_chaxun,
.mks-actions .public_saleWater_chaxun i {
	color: #fff !important;
}

.mks-actions .public_saleWater_daochu,
.mks-actions .public_saleWater_daochu i {
	color: #fff !important;
}

/* ── 统计卡片行 ── */
.mks-stat-row {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 14px;
}

.mks-stat-card {
	position: relative;
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 18px 20px;
	border: 1px solid rgba(217, 231, 243, .96);
	border-radius: 14px;
	background: #fff;
	box-shadow: 0 4px 16px rgba(31, 93, 154, .07);
	overflow: hidden;
}

.mks-stat-card::after {
	position: absolute;
	top: 0; left: 0;
	width: 100%; height: 3px;
	content: '';
}

.mks-stat-blue::after  { background: linear-gradient(90deg, #2689e8, #69c0ff, transparent); }
.mks-stat-green::after { background: linear-gradient(90deg, #08d691, #68f0c4, transparent); }
.mks-stat-orange::after{ background: linear-gradient(90deg, #ff6b35, #ffaa80, transparent); }

.mks-stat-icon {
	flex-shrink: 0;
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 12px;
	background: #f4f9ff;
}

.mks-stat-blue  .mks-stat-icon { background: rgba(38, 137, 232, .1); }
.mks-stat-green .mks-stat-icon { background: rgba(8, 214, 145, .1); }
.mks-stat-orange .mks-stat-icon { background: rgba(255, 107, 53, .1); }

.mks-stat-icon img {
	width: 28px;
	height: 28px;
}

.mks-stat-info {
	flex: 1;
	min-width: 0;
}

.mks-stat-label {
	color: #7b8fa6;
	font-size: 13px;
	margin-bottom: 6px;
}

.mks-stat-value {
	font-size: 28px;
	font-weight: 700;
	line-height: 1.2;
}

/* ── 表格卡片 ── */
.mks-table-card {
	overflow: visible;
}

.mks-table-card /deep/ .el-table__header-wrapper th {
	background: linear-gradient(180deg, #f4f9ff 0%, #edf6ff 100%) !important;
	color: #1a3550;
	font-weight: 700;
}

.mks-table-card /deep/ .el-table__body-wrapper {
	max-height: calc(100vh - 460px);
	overflow-y: auto;
}

.mks-table-card .pulbic_pagesize {
	display: flex;
	justify-content: flex-end;
	padding: 12px 0 0;
	border-top: 1px solid rgba(217, 231, 243, .8);
}

/* ── 展开行 ── */
.mks-table-card .yqmain {
	padding: 10px 16px;
	margin-bottom: 8px;
	border: 1px solid rgba(217, 231, 243, .8);
	border-radius: 10px;
	background: #f8fbff;
}

/* ── 弹窗详情 ── */
.DWD-li {
	display: flex;
	height: 35px;
	line-height: 35px;
	border: 1px solid #e0eaf4;
	border-radius: 0;
	font-size: 14px;
	color: #333;
	box-sizing: border-box;
}

.DWD-li + .DWD-li { border-top: none; }

.DWD-li > div {
	padding: 0 10px;
	height: 34px;
	overflow: hidden;
	box-sizing: border-box;
}

.DWD-li-title {
	flex-shrink: 0;
	width: 110px;
	text-align: center;
	border-right: 1px solid #e0eaf4;
	background: #f0f6ff;
	color: #2a5280;
	font-weight: 600;
}

.DWD-li-text { flex: 1; }

.DWD-li-text input {
	width: 100%;
	height: 34px;
	border: none;
	outline: none;
	background: transparent;
}

.DWD-table { display: flex; }

.DWD-table-left-flex { flex: 1; }

.DWD-table > div > div {
	padding: 0 8px;
	height: 34px;
	line-height: 34px;
	overflow: hidden;
	text-align: center;
	border-right: 1px solid #e0eaf4;
	border-bottom: 1px solid #e0eaf4;
	box-sizing: border-box;
	font-size: 13px;
}

.DWD-table > div > div:first-child { background: #f0f6ff; }

.DWD-table-left-title > div {
	width: 96px;
	text-align: center;
	background: #f0f6ff;
	color: #2a5280;
	font-weight: 600;
}

.DWD-table .DWD-table-left-title > div {
	padding: 0 8px;
	height: 34px;
	line-height: 34px;
	border-left: 1px solid #e0eaf4;
	border-bottom: 1px solid #e0eaf4;
	box-sizing: border-box;
}

.DetailsWater-img { margin-top: 20px; }

.DetailsWater-img-text {
	display: inline-block;
	width: 96px;
	text-align: center;
	vertical-align: top;
	color: #51687f;
	font-size: 13px;
}

/* ── 响应式 ── */
@media screen and (max-width: 1280px) {
	.mks-page { padding: 12px; }
	.mks-date-chips /deep/ .el-date-editor { width: 100%; }
	.mks-date-row { flex-direction: column; align-items: flex-start; }
	.mks-actions { width: 100%; }
}
</style>

<style>
	.el-form-item__label {
		width: 150px !important;
	}
</style>
<style>
.mar-keting-set-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.mar-keting-set-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.mar-keting-set-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.mar-keting-set-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.mar-keting-set-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
